import { Pipe } from '@angular/core';
var PowerPipe = (function () {
    function PowerPipe() {
    }
    PowerPipe.prototype.transform = function (num, power) {
        if (power === void 0) { power = 2; }
        return !isNaN(num)
            ? Math.pow(num, power)
            : num;
    };
    return PowerPipe;
}());
export { PowerPipe };
PowerPipe.decorators = [
    { type: Pipe, args: [{ name: 'pow' },] },
];
/** @nocollapse */
PowerPipe.ctorParameters = function () { return []; };
//# sourceMappingURL=pow.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/math/pow.js
// module id = 242
// module chunks = 4